module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    on: {
      "auth": _vm.auth,
      "logout": _vm.logout
    }
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "messageBar",
    attrs: {
      "md-position": "bottom center"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1022
// module chunks = 1